(() => {
	'use strict';

	const menuButton = document.querySelector('.navbar-toggler');
	const navigation = document.querySelector('.main-navigation');
	const primaryMenu = document.querySelector('#primary-menu');

	if (!menuButton || !navigation || !primaryMenu) {
		return;
	}

	const mobileQuery = window.matchMedia('(max-width: 1023px)');
	const NAVIGATION_BOTTOM_SPACE = 20;


	/*
	 * ==========================================
	 * SUBMENÜ
	 * ==========================================
	 */

	document.querySelectorAll('.menu-item-has-children').forEach((item) => {

		item.addEventListener('click', function(event) {

			if (event.target.closest('.sub-menu')) {
				return;
			}

			const subMenu = this.querySelector('.sub-menu');

			if (!subMenu) {
				return;
			}

			this.classList.toggle('active');
			subMenu.classList.toggle('active');


			// Nur Mobile muss die Hauptnavigation anpassen
			if (mobileQuery.matches) {

				requestAnimationFrame(() => {

					const height =
						primaryMenu.offsetHeight +
						NAVIGATION_BOTTOM_SPACE;

					navigation.style.height = `${height}px`;
				});
			}
		});
	});


	/*
	 * ==========================================
	 * AB HIER NUR MOBILE
	 * ==========================================
	 */

	if (!mobileQuery.matches) {
		return;
	}


	const setNavigationHeight = (height) => {
		navigation.style.height = `${height}px`;
	};


	const openNavigation = () => {

		navigation.classList.add('is-open');

		const height =
			primaryMenu.offsetHeight +
			NAVIGATION_BOTTOM_SPACE;

		setNavigationHeight(height);
	};


	const closeNavigation = () => {

		const height =
			primaryMenu.offsetHeight +
			NAVIGATION_BOTTOM_SPACE;

		setNavigationHeight(height);

		requestAnimationFrame(() => {

			setNavigationHeight(0);

			navigation.classList.remove('is-open');
		});
	};


	/*
	 * Hauptmenü Button
	 */

	menuButton.addEventListener('click', () => {

		const isOpen =
			menuButton.getAttribute('aria-expanded') === 'true';

		menuButton.setAttribute(
			'aria-expanded',
			String(!isOpen)
		);

		if (isOpen) {
			closeNavigation();
		} else {
			openNavigation();
		}
	});


	/*
	 * ESC
	 */

	document.addEventListener('keyup', (event) => {

		if (event.key !== 'Escape') {
			return;
		}

		if (!navigation.classList.contains('is-open')) {
			return;
		}

		menuButton.setAttribute('aria-expanded', 'false');

		closeNavigation();
	});	
	

})();





document.addEventListener('DOMContentLoaded', () => {
    const button = document.getElementById('btn-back-to-top');

    window.addEventListener('scroll', () => {
        if (window.scrollY > 200) {
            button.classList.add('visible');
        } else {
            button.classList.remove('visible');
        }
    });

    button.addEventListener('click', (event) => {
        event.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });

	// Sticky Header
    var viewportBreite;
    
    var dimensions = function () {
      viewportBreite = window.innerWidth;
    };

    window.addEventListener('load', function () {
        dimensions();
    });
    
    window.addEventListener('resize', function () {
        dimensions();
    });

    window.onscroll = function() {myFunction()};
    var header = document.getElementById('masthead');
    
    var sticky = header.offsetTop + 200;
    
    function myFunction() {
	  
      if (viewportBreite >= 1024) {
        if (window.pageYOffset > sticky) {
          header.classList.add('sticky');
          var navbar_height = header.offsetHeight;
          document.body.style.paddingTop = navbar_height + 'px';
        } else {
          header.classList.remove('sticky');
          document.body.style.paddingTop = '0';
        }
      }
    }	
});
